import React, { useEffect, useState } from "react";
import { Select } from "antd";

const { Option } = Select;

const formatHour = (hour) => {
  const h = hour % 24;
  const suffix = h >= 12 ? "PM" : "AM";
  const display = h % 12 === 0 ? 12 : h % 12;
  return `${display} ${suffix}`;
};

const hourOptions = Array.from({ length: 24 }, (_, hour) => ({
  value: hour,
  label: formatHour(hour),
}));

const generateHourArray = (start, end) => {
  if (start === end) return Array(24).fill(1);

  const arr = Array(24).fill(0);
  let i = start;
  while (true) {
    arr[i] = 1;
    if (i === (end - 1 + 24) % 24) break;
    i = (i + 1) % 24;
  }
  return arr;
};

const TimeRangeSelector = ({ onChange, disabled = false, defaultStart = 0, defaultEnd = 0 }) => {
  const [start, setStart] = useState(defaultStart);
  const [end, setEnd] = useState(defaultEnd);

  useEffect(() => {
    const arr = generateHourArray(start, end);
    onChange?.({ range: [start, end], array: arr });
  }, [start, end]);

  return (
    <section style={{ display: "grid", gridTemplateColumns: "90px min-content 90px", alignItems: "center", gap: 5, gridTemplateRows: 35 }}>
      <Select disabled={disabled} value={start} onChange={setStart} style={{ flex: 1, height: 24 }} options={hourOptions} />
      <p>to</p>
      <Select disabled={disabled} value={end} onChange={setEnd} style={{ flex: 1, height: 24 }} options={hourOptions} />
    </section>
  );
};

export { TimeRangeSelector, formatHour };
